module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu7WxKOzY.756af8e5.woff2";